import { render, staticRenderFns } from "./AFooterSocial.vue?vue&type=template&id=742ae090&scoped=true&functional=true&"
import script from "./AFooterSocial.vue?vue&type=script&lang=js&"
export * from "./AFooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./AFooterSocial.vue?vue&type=style&index=0&id=742ae090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "742ae090",
  null
  
)

export default component.exports